import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const headerStyle = {
  font: { bold: true, color: { argb: "FFFFFFFF" } },
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: "338BC7" } },
  alignment: { vertical: "middle", horizontal: "center", wrapText: true },
  border: {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" }
  }
};

const right = { alignment: { horizontal: "right" } };
const center = { alignment: { horizontal: "center" } };

export const exportAvancePoaExcel = async (data) => {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Informe Avance POA");

  ws.columns = [
    { header: "Producto", key: "producto", width: 25 },
    { header: "Actividad", key: "actividad", width: 25 },
    { header: "Responsable", key: "responsable_1", width: 25 },
    { header: "Tarea", key: "tarea", width: 30 },
    { header: "Unidad de medida", key: "unidad_medida", width: 18 },
    { header: "Meta", key: "meta", width: 12 },
    { header: "Medio de verificación", key: "medio_verificacion", width: 30 },
    { header: "Responsable 2", key: "responsable_2", width: 25 },
    { header: "Responsable 3", key: "responsable_3", width: 25 },
    { header: "Fecha Inicio Planeación", key: "fecha_inicio_planeacion", width: 18 },
    { header: "Fecha Fin Planeación", key: "fecha_fin_planeacion", width: 18 },
    { header: "Avance %", key: "avance", width: 12 },
    { header: "Fecha Inicio Ejecución", key: "fecha_inicio_logro", width: 18 },
    { header: "Fecha Fin Ejecución", key: "fecha_fin_logro", width: 18 },
    { header: "Logro", key: "logro", width: 12 },
    { header: "Logro Real", key: "logro_real", width: 12 },
    { header: "Comentario", key: "comentario", width: 40 }
  ];

  ws.getRow(1).eachCell(cell => Object.assign(cell, headerStyle));
  ws.getRow(1).height = 25;

  ws.views = [{ state: 'frozen', ySplit: 1 }];
  data.forEach(row => {
    const r = ws.addRow({
      ...row,
      fecha_inicio_planeacion: row.fecha_inicio_planeacion ? new Date(row.fecha_inicio_planeacion) : null,
      fecha_fin_planeacion: row.fecha_fin_planeacion ? new Date(row.fecha_fin_planeacion) : null,
      fecha_inicio_logro: row.fecha_inicio_logro ? new Date(row.fecha_inicio_logro) : null,
      fecha_fin_logro: row.fecha_fin_logro ? new Date(row.fecha_fin_logro) : null
    });

    r.getCell("fecha_inicio_planeacion").numFmt = "dd/mm/yyyy";
    r.getCell("fecha_fin_planeacion").numFmt = "dd/mm/yyyy";
    r.getCell("fecha_inicio_logro").numFmt = "dd/mm/yyyy";
    r.getCell("fecha_fin_logro").numFmt = "dd/mm/yyyy";
    r.getCell("meta").alignment = right;
    r.getCell("avance").alignment = right;
    r.getCell("logro").alignment = right;
    r.getCell("logro_real").alignment = right;
  });


  const buffer = await wb.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "Informe_Avance_POA.xlsx");
};



export const exportReporteProductoExcel = async (data) => {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Reporte Producto POA");

  ws.columns = [
    { header: "Producto", key: "producto", width: 30 },
    { header: "Logro Reportado", key: "logro_reportado", width: 18 },
    { header: "Año", key: "anio", width: 10 },
    { header: "AP", key: "ap", width: 12 },
    { header: "Municipios", key: "municipios_relacionados", width: 35 },
    { header: "Aplica", key: "aplica", width: 10 },
    { header: "Enlace", key: "enlace_verificacion", width: 40 },
    { header: "Actividad", key: "actividad", width: 25 },
    { header: "Tarea", key: "tarea", width: 30 }
  ];
  ws.getRow(1).eachCell(cell => Object.assign(cell, headerStyle));
  ws.getRow(1).height = 25;

  ws.views = [{ state: 'frozen', ySplit: 1 }];

  data.forEach(row => {
    const r = ws.addRow(row);

    r.getCell("logro_reportado").alignment = right;
    r.getCell("anio").alignment = center;
  });

  ws.columns.forEach(col => {
    col.alignment = { wrapText: true };
  });

  const buffer = await wb.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "Reporte_Producto_POA.xlsx");
};